import {IconButton} from '@jetbrains/teamcity-ui/dist/components'
import {resolveRelative} from '@jetbrains/teamcity-ui/dist/utils'
import classNames from 'classnames'

import {showDownloadAllArtifactsLink} from '../../../../utils/featureToggles'

import styles from './ArtifactsDownloadAll.module.css'

import {stringifyId} from 'src/types'
import type {BuildId, BuildTypeId} from 'src/types'

type Props = {
  className?: string
  buildId?: BuildId
  buildType?: BuildTypeId | null | undefined
  showHidden?: boolean | null | undefined
  compact?: boolean
}

export default function ArtifactsDownloadAll({
  className,
  buildId,
  buildType,
  showHidden,
  compact,
}: Props) {
  if (!showDownloadAllArtifactsLink) {
    return null
  }

  return (
    <IconButton
      href={resolveRelative(
        `/repository/downloadAll/${stringifyId(buildType)}/${stringifyId(
          buildId,
        )}:id/artifacts.zip${showHidden === true ? '?showAll=true' : ''}`,
      )}
      className={classNames(styles.downloadLink, className)}
      icon="download"
      title="Download all"
      withBorder={!compact}
    >
      {compact ? null : 'Download all'}
    </IconButton>
  )
}
